import { Box, Typography } from "@material-ui/core";
import { Download } from "@mui/icons-material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Grid, Link, styled } from "@mui/material";
import React, { useContext, useRef, useState } from "react";

import { offer_id, offer_name, tag_id, tag_name } from "../../../constants";
import { primary } from "../../../constants/theme";
import { VehicleBrochure } from "../../../constants/vehicleData";
import { Context } from "../../../context/context";
import { MemoizedButton } from "../../../SDK/button";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { leadActions } from "../../../utils/leadActions";
import EMICalulator from "../../EmiCalculator/EmiCalculator";

const CustomVehicleData = styled(Box)(({ theme }) => ({
  ".main-box": {
    marginBottom: "60px",
  },
  ".vehicle-data-brand": {
    fontWeight: "600",
    fontSize: "36px",
    lineHeight: "150%",
    color: primary.dark,
    textTransform: "Capitalize",
  },
  ".vehicle-data-name": {
    fontWeight: "600",
    fontSize: "22px",
    lineHeight: "34px",
    color: "#BDBDBD",
    textTransform: "Capitalize",
  },
  ".details-box": {
    maxWidth: "520px",
    width: "100%",
    marginLeft: "-30px",
  },
  ".details-box .details-grid-item": {
    borderRight: `2px solid ${primary.main}`,
    paddingLeft: "30px",
    paddingTop: "4px",
    "&:last-child": {
      borderRight: "unset",
    },
  },
  ".details-head": {
    fontWeight: "400",
    fontSize: "1em",
    lineHeight: "1.5em",
    color: "#000000",
  },
  ".details-desc": {
    fontWeight: "700",
    fontSize: "1.5em",
    lineHeight: "1.5em",
    color: "#000000",
  },
  ".download-brochure": {
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "172.02%",
    color: primary.main,
    marginTop: "20px",
    fontFamily: `'Poppins', sans-serif`,
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  ".prices-box": {
    background: primary.secondaryGreen,
    borderRadius: "20px",
    padding: "0px 25px 25px 0px",
    marginTop: "16px",
    position: "relative",
    maxWidth: "620px",
  },
  ".range-performance": {
    fontSize: "12px",
    fontWeight: "700px !important",
  },
  ".prices-starting": {
    background: "#5D3DB3",
    borderRadius: "200px",
    padding: "4px 22px",
    fontStyle: "italic",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "130%",
    marginBottom: "10px",
    color: primary.white,
    width: "fit-content",
  },
  ".prices-box-grid": {
    padding: "0px 0px 0px 25px",
    textAlign: "center",
  },
  ".prices-box-grid .prices-box-grid-item": {
    borderRight: `2px solid #000`,
    "&:last-child": {
      borderRight: "unset",
    },
  },
  ".price-type": {
    fontWeight: "600",
    fontSize: "24px",
    lineHeight: "35px",
    color: primary.secondary,
  },
  ".price-data": {
    fontWeight: "600",
    fontSize: "46px",
    lineHeight: "70px",
    color: "#000",
  },
  ".description": {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "150%",
    color: "#666666",
  },
  ".Whatsapp-main": {
    bottom: "0",
    marginBottom: "16px",
    paddingRight: "80px",
    position: "fixed",
    right: "26px",
    textAlign: "end",
    zIndex: "999",
  },
  ".whatsapp": {
    background: "#35BF68",
    borderRadius: "50%",
    width: "fit-content",
    padding: "9px 10px 8px 10px",
    marginLeft: "auto",
  },
  ".whatsapp svg": {
    color: primary.white,
    width: "70px",
    height: "70px",
  },
  ".chat-with-us": {
    display: "block",
    background: primary.white,
    borderRadius: "4px",
    boxShadow: "0 1px 2px rgb(0 0 0 / 25%)",
    color: "#333",
    fontFamily: "Poppins",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "14px",
    maxWidth: "360px",
    padding: "3px 6px",
    textAlign: "center",
    width: "108px",
    marginTop: "5px",
    paddingRight: "3px",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginLeft: "-10px",
  },
  ".why-turno": {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    alignItems: "end",
  },
  ".why-turno-heading": {
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "capitalize",
    color: primary.dark,
    marginLeft: "10px",
    marginBottom: "10px",
  },
  ".benefit-why-turno": {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "16px",
    textTransform: "capitalize",
    color: primary.dark,
    margin: "unset",
  },
  ".book-now-btn": {
    padding: "12px 46px 12px 46px",
  },
  li: {
    padding: "unset",
  },
  ".avatar-list": {
    minWidth: "32px",
    marginLeft: "10px",
  },
  ".avatar-list svg": {
    color: "#35bf68",
  },

  ".emi-cta": {
    borderRadius: "4px",
    background: primary.main,
    // boxShadow: "none",
    // border: "none",
    color: primary.white,
    fontSize: "10px",
    padding: "5px",
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    padding: "32px 16px 0px",
    ".main-box": {
      marginBottom: "20px",
    },
    ".details-head": {
      fontSize: "0.7em",
    },
    ".details-desc": {
      fontSize: "1em",
    },
    ".details-box": {
      marginLeft: "-16px",
    },
    ".details-box .details-grid-item": {
      paddingLeft: "20px",
    },
    ".vehicle-data-brand": {
      fontSize: "24px",
      lineHeight: "30px",
    },
    ".vehicle-data-name": {
      fontSize: "18px",
      lineHeight: "24px",
    },
    ".download-brochure": {
      fontSize: "14px",
      lineHeight: "12px",
      marginTop: "14px",
    },
    ".prices-box": {
      marginTop: "24px",
      paddingBottom: "12px",
    },
    ".prices-starting": {
      fontSize: "14px",
      lineHeight: "20px",
      padding: "4px 16px",
    },
    ".price-type": {
      fontSize: "18px",
      lineHeight: "24px",
    },
    ".price-data": {
      fontSize: "28px",
      lineHeight: "52px",
    },
    ".prices-box-grid": {
      paddingLeft: "0px",
      marginTop: "10px",
      marginLeft: "0px",
    },
    ".description": {
      fontSize: "12px",
      textAlign: "center",
    },
    ".chat-with-us": {
      fontSize: "9px",
      lineHeight: "14px",
      marginLeft: "auto",
      padding: "3px 6px",
      width: "fit-content",
    },
    ".Whatsapp-main": {
      height: "unset",
      bottom: "112px",
      marginBottom: "16px",
      paddingRight: "12px",
      position: "fixed",
      right: "0px",
      textAlign: "end",
      zIndex: "999",
    },
    ".whatsapp svg": {
      color: primary.white,
      width: "30px",
      height: "30px",
    },
    ".why-turno": {
      alignItems: "center",
      background: "#fff",
      bottom: "0",
      boxShadow: "0 -1px 4px rgb(0 0 0 / 10%)",
      color: "#333",
      maxWidth: "520px",
      padding: "5px 8px 5px 8px",
      position: "fixed",
      width: "100%",
      zIndex: "999",
      marginLeft: "-16px",
    },
    ".why-turno-heading, .benefit-why-turno span": {
      fontSize: "10.2857px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "15px",
    },
    ".avatar-list": {
      minWidth: "24px",
    },
    ".avatar-list svg": {
      width: "15px",
      height: "15px",
      color: "#35bf68",
    },
    ".book-now-btn": {
      height: "38px",
      width: "160px",
      padding: "4px 0px",
    },
    ".prices-box-grid .prices-box-grid-item": {
      paddingTop: "0px",
    },

    ".emi-cta": {
      display: "flex",
      borderRadius: "4px",
      background: primary.main,
      boxShadow: "none",
      border: "none",
      color: primary.white,
      fontSize: "10px",
      padding: "5px",
      alignItems: "center",
    },
  },
}));

const VehicleDetailsData = ({ vehicleData, price, emiPrice, type }) => {
  const { showWhatsappPopup, showStatePopup, hideStatePopup, changeState } =
    useContext(Context);
  const [showBookNow, setShowBookNow] = useState(true);

  const [openEmiCalc, setOpenEmiCalc] = useState(false);

  const targetRef = useRef();
  //const { hideStatePopup, changeState } = useContext(Context);
  //const navigate = useRouter();

  const handleEmiCalculator = () => {
    setOpenEmiCalc(!openEmiCalc);

    sendAnalytics("calculate_emi_clicked", {}, "en");
    changeState("Karnataka");
  };

  // useEffect(() => {
  //   const options = {
  //     root: null,
  //     rootMargin: "0px",
  //     threshold: 0.8,
  //   };

  //   const observer = new IntersectionObserver((entries) => {
  //     const [entry] = entries;

  //     if (entry.isIntersecting) {
  //       //sendAnalytics("scroll_first_fold_form", {}, "en");

  //       setOpenEmiCalc(false);
  //     }
  //   }, options);

  //   if (targetRef.current) observer.observe(targetRef.current);

  //   return () => {
  //     if (targetRef.current) observer.unobserve(targetRef.current);
  //   };
  // }, [targetRef]);

  return (
    <CustomVehicleData>
      <Box sx={{ maxWidth: "620px", width: "100%" }} className="main-box">
        <Typography variant="h2" className="vehicle-data-brand">
          {vehicleData?.brand}{" "}
          {/* </Typography>
        <Typography className="vehicle-data-name"> */}
          {vehicleData?.vehicle_name}
        </Typography>
        <Box className="prices-box">
          <Typography className="prices-starting">
            Prices starting at
          </Typography>
          <Grid container spacing={2} className="prices-box-grid">
            <Grid
              sx={{ display: "block" }}
              className="prices-box-grid-item"
              item
              xs={6}
              md={6}
            >
              <Typography className="price-type">Monthly EMI</Typography>
              <Typography className="price-data">
                ₹ {emiPrice} <sup>*</sup>
              </Typography>

              <Box style={{ display: "flex", justifyContent: "center" }}>
                {" "}
                <MemoizedButton
                  animated={true}
                  content={"Calculate your EMI’s"}
                  className={"emi-cta"}
                  endIcon={<KeyboardDoubleArrowRightIcon />}
                  onClick={() => {
                    handleEmiCalculator();
                    leadActions("CLICK_SAVINGS_ESTIMATION");
                  }}
                />
              </Box>

              {/* <Typography className="price-data">
                ₹ {emiPrice} <sup>*</sup>
              </Typography> */}
            </Grid>
            <Grid
              sx={{ display: "block" }}
              className="prices-box-grid-item"
              item
              xs={6}
              md={6}
            >
              <Typography className="price-type">Full price(Lakhs)</Typography>
              <Typography className="price-data">
                ₹ {price}L<sup>*</sup>
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Typography className="description">
          {" "}
          *Prices are indicative and may vary by location
        </Typography>

        <Box id="emi">
          {openEmiCalc && (
            <EMICalulator
              loanAmount={parseInt(price * 100000)}
              vehicleData={vehicleData}
            />
          )}
        </Box>

        <Box
          style={{
            background: "#EBF9F0",
            borderRadius: "20px",
            padding: "10px 20px 20px 20px",
            marginTop: "20px",
          }}
        >
          <Box
            style={{
              maxWidth: "200px",
              background: "#5D3DB3",
              color: "white",
              borderRadius: "20px",
              padding: "5px",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            <Typography
              className="range-performance"
              style={{ fontWeight: "600" }}
            >
              RANGE AND PERFORMANCE
            </Typography>
          </Box>
          <Grid
            container
            spacing={2}
            className="details-box"
            sx={{ mt: { xs: "24px", md: "20px" } }}
          >
            <Grid
              sx={{ display: "block" }}
              className="details-grid-item"
              item
              xs={4}
              md={4}
            >
              <Typography className="details-head">Load capacity</Typography>
              <Typography className="details-desc">
                {vehicleData?.load}
              </Typography>
            </Grid>
            <Grid
              sx={{ display: "block" }}
              className="details-grid-item"
              item
              xs={4}
              md={4}
            >
              <Typography className="details-head">Battery Range</Typography>
              <Typography className="details-desc">
                {vehicleData?.range}
              </Typography>
            </Grid>
            <Grid
              sx={{ display: "block" }}
              className="details-grid-item"
              item
              xs={4}
              md={4}
            >
              <Typography className="details-head">Charging Time </Typography>
              <Typography className="details-desc">
                {vehicleData?.chargingtime}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            className="details-box"
            sx={{ mt: { xs: "24px", md: "40px" } }}
          >
            <Grid
              sx={{ display: "block" }}
              className="details-grid-item"
              item
              xs={4}
              md={4}
            >
              <Typography className="details-head">
                Battery warranty{" "}
              </Typography>
              <Typography className="details-desc">
                {vehicleData?.warrantyBattery}
              </Typography>
            </Grid>
            <Grid
              sx={{ display: "block" }}
              className="details-grid-item"
              item
              xs={4}
              md={4}
            >
              <Typography className="details-head">
                Battery Capacity{" "}
              </Typography>
              <Typography className="details-desc">
                {vehicleData?.batteryCapacity}
              </Typography>
            </Grid>
            <Grid
              sx={{ display: "block" }}
              className="details-grid-item"
              item
              xs={4}
              md={4}
            >
              <Typography className="details-head">Top speed</Typography>
              <Typography className="details-desc">
                {vehicleData?.topSpeed}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Link
          id="performance-range"
          ref={targetRef}
          target="_blank"
          href={
            VehicleBrochure[vehicleData?.vehicle_name] ||
            VehicleBrochure[vehicleData?.brand?.toLowerCase()]
          }
          hrefLang={"en"}
          rel="noreferrer"
          underline="none"
          onClick={() => {
            let payload = {
              vehicle_name: vehicleData?.vehicle_name,
              vehicle_id: vehicleData?.vehicle_id,
              price_shown: price,
              emi_shown: emiPrice,
              offer_name: offer_name,
              offer_id: offer_id,
              tag_name: tag_name,
              tag_id: tag_id,
            };
            sendAnalytics("download_brouchure_button_clicked", payload, "en");
          }}
        >
          <Box className="download-brochure">
            <Download />
            Download Brochure{" "}
          </Box>
        </Link>

        {/* {showBookNow && (
          <MemoizedWhyTurno
            vehicleDetails={vehicleData}
            setShowBookNow={setShowBookNow}
          />
        )} */}

        {/* <Box
          className="Whatsapp-main"
          sx={{ maxWidth: "100px", width: "100%", margin: "auto" }}
          onClick={() => {
            createCookieInHour(
              "lead_trigger",
              "whatsapp_chat_floating_icon",
              10
            );
            let payload = {
              vehicle_name: vehicleData?.vehicle_name,
              vehicle_id: vehicleData?.vehicle_id,
              price_shown: price,
              emi_shown: emiPrice,
              offer_name: offer_name,
              offer_id: offer_id,
              tag_name: tag_name,
              tag_id: tag_id,
              connect_type: "floating chat icon",
            };
            sendAnalytics("whatsapp_connect_button_clicked", payload, "en");
            showWhatsappPopup("floating chat icon");
          }}
        >
          <Box className="whatsapp">
            <WhatsApp className="whatsapp-logo" />
          </Box>
          <Typography className="chat-with-us">Chat with us</Typography>
        </Box> */}
      </Box>
    </CustomVehicleData>
  );
};

export const MemoizedVehicleDetailsData = React.memo(VehicleDetailsData);
